import React from 'react';
export function HeroSection() {
  return <section className="relative flex items-start border-b border-gray-200" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/pNgmdMpsT1HhP2wac6GkmJ/hero-b.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center top'
  }} data-id="element-179">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-180">
        <div className="max-w-3xl mx-auto text-center" style={{
        paddingTop: '5vw',
        paddingBottom: '9vw'
      }} data-id="element-181">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-182">
            GNLD Neolife Vitamins, Supplements and Products are simply the{' '}
            <span className="text-[#0e7be1]" data-id="element-183">
              finest, safest and most effective
            </span>{' '}
            products in the world!
          </h1>

          <div className="w-16 h-0.5 bg-[#9fd23d] mx-auto mb-6" data-id="element-184"></div>

          <p className="text-base lg:text-lg text-gray-900 font-bold leading-relaxed" data-id="element-185">
            Since 1958, Neolife has been helping millions of people fix their
            health issues! Stop wasting your money on vitamins that don't work!
            Use Neolife and{' '}
            <span className="text-[#0e7be1]" data-id="element-186">See results in just days!</span>
          </p>

          <p className="text-sm text-gray-700 mt-4 bg-white/80 backdrop-blur-sm inline-block px-4 py-2 rounded-full" data-id="element-187">
            NeoLife products are available at retail prices, with up to 25%
            savings available through free membership enrollment.
          </p>
        </div>
      </div>
    </section>;
}